import { useEffect, useRef } from "react";

// Preserve selections inside the menu and let outside controls act normally.
export default function useDismissMenu(open, setOpen, { preserveDialogs = false } = {}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const outside = (event) => {
      if (preserveDialogs && event.target?.closest?.('dialog[open]')) return;
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    const escape = (event) => {
      if (event.key !== "Escape") return;
      if (preserveDialogs && document.querySelector('dialog[open]')) return;
      setOpen(false);
      ref.current?.querySelector("[aria-expanded], summary")?.focus();
    };
    document.addEventListener("pointerdown", outside, true);
    document.addEventListener("focusin", outside);
    document.addEventListener("keydown", escape);
    return () => {
      document.removeEventListener("pointerdown", outside, true);
      document.removeEventListener("focusin", outside);
      document.removeEventListener("keydown", escape);
    };
  }, [open, setOpen, preserveDialogs]);
  return ref;
}
